import TaxStatementsServices from './TaxStatementsServices';
import TaxStatementsServicesMock from './TaxStatementsServiceMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? TaxStatementsServicesMock : TaxStatementsServices;
